export default "__VITE_ASSET__QZMDvjeF__"